import React from 'react'
import LazyLoad from 'react-lazyload';
import { useEffect } from 'react'; 
import Highlights from '../Component/Highlights'
import { useLocation, NavLink } from 'react-router-dom'; 
import { Link } from 'react-router-dom';
const Header = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  return (
        <> 
        <div className="headtop"> 
            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/highlighticn.gif" className="img-fluid"/>
           <Highlights/>
           <div className="headertopright highlight-tab"> 
                    <p className="d-flex space-even highlight-blk"> 
                    <a href="#" target="_blank"><LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/linkdin.png'></img></LazyLoad>
                    </a>
                    <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/line.png'></img></LazyLoad>
                    <a href="#" target="_blank"><LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/twitter.png'></img></LazyLoad>
                    </a> 
                    <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/line.png'></img></LazyLoad> 
                    <a href="#" target="_blank"><LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/insta.png'></img></LazyLoad></a>  
                    </p> 
            </div>
        </div>
        <div className="clr"></div>
        <div className="header"> 
            <div className="logo">
                <Link to="/"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/logo.png" alt="MMATD" className="img-fluid"/></Link>
            </div> 
                 <div className="headermidleft">
                       <div className="headermidleftimg">
                             <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/phoneicn.gif" alt="MMATD" className="img-fluid"/>
                              <p><Link to="tel:+918056851655">+91 8056851655</Link> <br/>
                              <Link to="tel:++918015471655">+91 8015471655</Link></p>
                       </div>
                       <div className="headermidleftimg">
                             <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/mail.gif" alt="MMATD" className="img-fluid"/>
                             <Link to="mailto:mmcmiacademy@gmail.com">mmcmiacademy@gmail.com</Link> <br/> 
                       </div> 
                       <div className="headermidbottom">
                         <Link to="https://entab.online/MMCMIA" target="_blank"> Campus Login</Link> 
                          <Link to="/" target="_blank"> Career</Link> 
                 </div>
                 </div>  
            <div className="headerright">
            <ul>
                    <li> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/headerimg1.png" alt="MMATD" className="img-fluid"/>  </li>
                    <li> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/headerimg2.png" alt="MMATD" className="img-fluid"/>  </li>
                    
                </ul>
            </div>

        </div>
        <div className="header-nav"> 
            <nav className="navbar navbar-expand-lg">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav"> 
                <li className="nav-item">  <NavLink className="nav-link" to="/"> Home  </NavLink></li>
                  { /*    <li className="nav-item dropdown"> 
                <div className="nav-link" data-bs-toggle="dropdown"> About Us </div> 
                        <ul className="dropdown-menu fade-up"> 
                                <li><NavLink to="/">History </NavLink></li> 
                                <li><NavLink to="/">Vision and Mission </NavLink></li> 
                                <li><NavLink to="/">Management Commitee </NavLink></li>
                                <li><NavLink to="/">Principal's Message </NavLink></li> 
                                <li className="innersubmenu">
                                <a href="javascript:void(0)" className="menu-item"> Prefectorial Board <span><i class="bi bi-caret-right-fill"></i></span></a>
                                <ul className="dropdown-menu"> 
                                    <li><NavLink to="/">Junior Board </NavLink></li> 
                                     <li><NavLink to="/">Senior Board </NavLink></li>  
                                </ul>
                            </li> 
                                <li><NavLink to="/">FAQ </NavLink></li> 
                                <li><NavLink to="/">School Information - CBSE </NavLink></li> 
                                <li><NavLink to="/">Contact Us </NavLink></li> 
                               
                                <li><NavLink to="/">School Videos </NavLink></li> 
                        </ul>   
                </li> */ }
                <li className="nav-item dropdown"> 
                    <div className="nav-link" data-bs-toggle="dropdown"> School </div> 
                        <ul className="dropdown-menu fade-up"> 
                                <li><NavLink to="/AboutUs">About Us </NavLink></li> 
                                <li><NavLink to="/OurVision">Our Vision </NavLink></li> 
                                <li><NavLink to="/OurMotto">Our Motto </NavLink></li> 
                                <li><NavLink to="/WhoWeAre"> Who We Are</NavLink></li> 
                                <li><NavLink to="/Management">Management   </NavLink></li>  
                        </ul>   
                </li> 
                    <li className="nav-item">  <NavLink className="nav-link" to="/AdmissionEligibility">Admission   </NavLink> </li> 
                    <li className="nav-item dropdown"> 
                        <div className="nav-link" data-bs-toggle="dropdown"> Academic </div> 
                            <ul className="dropdown-menu fade-up"> 
                                    <li><NavLink to="/CMIEducationPolicy">CMI Education Policy </NavLink></li>   
                            </ul>   
                    </li> 
                    <li className="nav-item">  <NavLink className="nav-link" to="/Facilities">   Facilities  </NavLink> </li> 
                    <li className="nav-item">  <NavLink className="nav-link" to="/CbseDisclosure">   CBSE  </NavLink> </li> 

                    <li className="nav-item dropdown"> 
                    <div className="nav-link" data-bs-toggle="dropdown"> Gallery </div> 
                        <ul className="dropdown-menu fade-up"> 
                                <li><NavLink to="/Gallery">Gallery </NavLink></li> 
                                <li><NavLink to="/VideoGallery">Video Gallery </NavLink></li>    
                        </ul>   
                </li>
                 
                    <li className="nav-item">  <NavLink className="nav-link" to="/ContactUs">  Contact Us </NavLink> </li> 
                </ul>
                </div> 
           </nav>
        </div> 
 
    </>
  )
}

export default Header
